import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

/** Rendered only when LAYOUT.footerVisible is true. */
@Component({
  selector: 'rms-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [TranslateModule],
})
export class FooterComponent {}
